import { useCallback } from 'react'
import type {
  TGetGrowthToolsCursorQueryParams,
  TGetGrowthToolsQueryParams,
  TGrowthToolsCursorPage,
} from '../api/types/growthTools'
import { CURSOR_LIST_PAGE_SIZE } from '../consts/api'
import { useWindowedCursorList } from './useWindowedCursorList'

type LoadGrowthToolsPage = (
  arg: TGetGrowthToolsCursorQueryParams,
  preferCacheValue?: boolean,
) => { unwrap: () => Promise<TGrowthToolsCursorPage> }

export function useGrowthToolsWindowedPage(
  resetKey: string | number,
  loadPage: LoadGrowthToolsPage,
  queryArgs: TGetGrowthToolsQueryParams,
) {
  const fetchPage = useCallback(
    async (cursor: string | null) => {
      const data = await loadPage({ ...queryArgs, cursor, limit: CURSOR_LIST_PAGE_SIZE }, true).unwrap()
      return {
        items: data.items ?? [],
        nextCursor: data.meta?.next_cursor ?? null,
      }
    },
    [loadPage, queryArgs],
  )

  return useWindowedCursorList({
    resetKey,
    fetchPage,
  })
}
